import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
import reservations from './reservations'
import customers from './customers'
import draftReservations from './draft-reservations'
import equipment from './equipment'
import maintenance from './maintenance'
import prices from './prices'
import transportPrices from './transport-prices'
import telemetry from './telemetry'
import auditLogs from './audit-logs'
import authenticationLogs from './authentication-logs'
import errors from './errors'
import api from './api'
/**
* @see \App\Http\Controllers\Admin\DashboardController::dashboard
* @see app/Http/Controllers/Admin/DashboardController.php:30
* @route '/admin'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/admin',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DashboardController::dashboard
* @see app/Http/Controllers/Admin/DashboardController.php:30
* @route '/admin'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DashboardController::dashboard
* @see app/Http/Controllers/Admin/DashboardController.php:30
* @route '/admin'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::dashboard
* @see app/Http/Controllers/Admin/DashboardController.php:30
* @route '/admin'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::statistics
* @see app/Http/Controllers/Admin/DashboardController.php:163
* @route '/admin/statistics'
*/
export const statistics = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statistics.url(options),
    method: 'get',
})

statistics.definition = {
    methods: ["get","head"],
    url: '/admin/statistics',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\DashboardController::statistics
* @see app/Http/Controllers/Admin/DashboardController.php:163
* @route '/admin/statistics'
*/
statistics.url = (options?: RouteQueryOptions) => {
    return statistics.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\DashboardController::statistics
* @see app/Http/Controllers/Admin/DashboardController.php:163
* @route '/admin/statistics'
*/
statistics.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: statistics.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\DashboardController::statistics
* @see app/Http/Controllers/Admin/DashboardController.php:163
* @route '/admin/statistics'
*/
statistics.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: statistics.url(options),
    method: 'head',
})

const admin = {
    dashboard: Object.assign(dashboard, dashboard),
    reservations: Object.assign(reservations, reservations),
    customers: Object.assign(customers, customers),
    draftReservations: Object.assign(draftReservations, draftReservations),
    equipment: Object.assign(equipment, equipment),
    maintenance: Object.assign(maintenance, maintenance),
    prices: Object.assign(prices, prices),
    transportPrices: Object.assign(transportPrices, transportPrices),
    telemetry: Object.assign(telemetry, telemetry),
    statistics: Object.assign(statistics, statistics),
    auditLogs: Object.assign(auditLogs, auditLogs),
    authenticationLogs: Object.assign(authenticationLogs, authenticationLogs),
    errors: Object.assign(errors, errors),
    api: Object.assign(api, api),
}

export default admin